export { SearchSwitchingPage as default } from '@moonpig/web-explore-find'
